/* global exports */
"use strict";
import Modal from "bootstrap/js/dist/modal";
import * as modalUtils from "../../client/js/utils/modal.ts";

const progressDOMel = document.getElementById("progress");

/**
 * Init progress modal only once
 */
function initModal() {
  if (progressDOMel) {
    const progressModalInstance = Modal.getInstance(progressDOMel);

    if (!progressModalInstance) {
      const newProgressModal = new Modal(progressDOMel, {
        keyboard: false,
        backdrop: "static",
      });
    }

    progressDOMel.addEventListener("show.bs.modal", () => {
      $("#progress .progress-bar")
        .css("width", 0)
        .animate({ width: "100%" }, 3000, "swing", function () {
          modalUtils.hideModalBs5(progressDOMel);
        });
    });
  }
}

export function showProgress(msg) {
  return function () {
    initModal();
    $("#progress .progress-message").text(msg);
    modalUtils.showModalBs5(progressDOMel);
  };
}

export function hideProgress() {
  modalUtils.hideModalBs5(progressDOMel);
}
